export const flags = {
     show_passkey : true,
     show_passkey_as_mfa: true, //for all types of users
     show_reset_totp: true,
     show_reset_sms: true,
     show_state_dropdown: true,
     show_revoke_consent: true,
     show_recovery_codes: true,
     show_trusted_devices: true
}

export const configs = {
     totp_reset_end_date : "Jan 31, 2025",
     sms_mfa_end_date: "Apr 02, 2025",
     unsupported_languages : [
          "bg-BG",
          "cs-CZ",
          "el-GR",
          "es-ES",
          "hu-HU",
          "pl-PL",
          "pt-PT",
          "ro-RO",
          "sl-SI",
          "th-TH",
          "tr-TR"
      ]
}

export const external_links = {
     language_warning: "https://help.trimble.com/en/trimble-account-services/trimble-account-services/sign-in-and-profile/getting-started-with-trimble-id/supported-languages-in-trimble-id",
     passkey_learn_more: "https://help.trimble.com/en/trimble-account-services/trimble-account-services/sign-in-and-profile/manage-my-trimble-id-profile/trimble-id-passkeys-faq"
}